import { ArrowRight } from "lucide-react";
import { SERVICES } from "../constants";
import { Reveal } from "./Reveal";

const Services = ({ onRequestService }) => (
    <section id="services" className="py-16 sm:py-24 lg:py-32 bg-white" data-testid="services-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
            <div className="max-w-3xl">
                <Reveal>
                    <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#0B5CF5] mb-4">Launching first</p>
                </Reveal>
                <Reveal delay={0.08}>
                    <h2 className="font-display font-medium text-slate-900 text-2xl sm:text-3xl lg:text-4xl tracking-tight leading-[1.1]">
                        Starting with the little things that make a{" "}
                        <span className="italic text-[#0B5CF5]">big difference.</span>
                    </h2>
                </Reveal>
                <Reveal delay={0.16}>
                    <p className="mt-5 text-base sm:text-lg text-slate-600 leading-relaxed">
                        Our first category is everyday maid and household assistance — the essential chores
                        that keep a home running, done with care and respect.
                    </p>
                </Reveal>
            </div>

            <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                {SERVICES.map((s, i) => (
                    <Reveal key={s.title} delay={i * 0.1}>
                        <div
                            className="group relative rounded-3xl overflow-hidden h-80 sm:h-96 shadow-[0_16px_50px_-18px_rgba(15,23,42,0.25)]"
                            data-testid={`initial-service-card-${i}`}
                        >
                            <img
                                src={s.image}
                                alt={s.title}
                                loading="lazy"
                                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-110"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-[#0F172A]/85 via-[#0F172A]/20 to-transparent" />
                            <div className="absolute inset-x-0 bottom-0 p-6">
                                <span className="inline-block text-[10px] font-bold uppercase tracking-[0.18em] text-white/90 bg-[#0B5CF5] rounded-full px-3 py-1 mb-3">
                                    Core service
                                </span>
                                <h3 className="text-xl font-bold text-white tracking-tight">{s.title}</h3>
                                <p className="mt-1.5 text-sm text-white/80 leading-relaxed max-h-0 opacity-0 overflow-hidden transition-all duration-500 group-hover:max-h-24 group-hover:opacity-100">
                                    {s.desc}
                                </p>
                            </div>
                        </div>
                    </Reveal>
                ))}
            </div>

            <Reveal delay={0.2}>
                <div className="mt-12 flex flex-col items-center text-center">
                    <p className="text-sm text-slate-500 mb-4">
                        Need one of these at home? Tell us where you are.
                    </p>
                    <button
                        data-testid="services-request-service-button"
                        onClick={onRequestService}
                        className="btn-primary inline-flex items-center gap-2 px-7 py-3.5 text-sm sm:text-base"
                    >
                        Request a Service <ArrowRight size={18} />
                    </button>
                </div>
            </Reveal>
        </div>
    </section>
);

export default Services;
